
const AffiliationInfoConfirm = ({ fields, viewMode, member, mt }) => {

  return (
    <>
                <h3>所属先</h3>
              <dl>
                <dt>名称<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationName : fields.affiliationName}</dd>
                <dt>{ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? '学部・学科等' : '部署' }<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationDepertment : fields.affiliationDepertment}&nbsp;</dd>
                <dt style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>職名</dt>
                <dd style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>{viewMode ? member.affiliationPosition : fields.affiliationPosition}&nbsp;</dd>
                <dt style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>職種<span class="red">*</span></dt>
                <dd style={ mt == 14 || mt == 15 || mt == 16 || mt == 17 ? { "display": "none" } : {} }>{viewMode ? member.affiliationOccupation : fields.affiliationOccupation}&nbsp;</dd>
                <dt>郵便番号<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationPostalCode : fields.affiliationPostalCode}&nbsp;</dd>
                <dt>所在地<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationAddress.replace('#',' ') : fields.affiliationAddress.replace('#',' ')}&nbsp;</dd>
                <dt>所在地（フリガナ）<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationAddressKana : fields.affiliationAddressKana}&nbsp;</dd>
                <dt>電話番号<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationTel : fields.affiliationTel}&nbsp;</dd>
                <dt>FAX</dt>
          <dd>{ (viewMode ? member.affiliationFax : fields.affiliationFax) ? (viewMode ? member.affiliationFax: fields.affiliationFax) : '' }&nbsp;</dd>
                <dt>Email<span class="red">*</span></dt>
                <dd>{viewMode ? member.affiliationEmail : fields.affiliationEmail}</dd>
                </dl>
    </>
  );
}

export default AffiliationInfoConfirm;
